import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-pagination', 'title', 'Puslapių naršymas');
Labels.set('ui-pagination', 'previousPage', 'Ankstesnis puslapis');
Labels.set('ui-pagination', 'nextPage', 'Kitas puslapis');
Labels.set('ui-pagination', 'currentPage', 'Dabartinis puslapis');
Labels.set('ui-pagination', 'page', 'Puslapis');
Labels.set('ui-pagination', 'show', 'Rodyti kiekviename puslapyje');
